export class FirstHydroInstructionDto {
    units: string = "";
    issuedFrom: Date | string = new Date().toISOString().split('T')[0];
    issuedTo: Date | string = new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0];
    dateComment: string = "";
    comments: string = "";
    createdBy: string = "";
    createdOn: Date = new Date();
    instructionData: InstructionDataDto = new InstructionDataDto();
    status: string = "";
    isArchived: boolean = false;



}
export class InstructionDataDto {
    waterCommitment: string = "";
    maxContractBookCommitmentByEFABlocks: string = "";
    maxContractEFABlocks: EFABlockDto[] = new Array<EFABlockDto>();
    spreads: string = "";
    spreadsFFES: SpreadsDto[] = new Array<SpreadsDto>();
    spreadsDINO: SpreadsDto[] = new Array<SpreadsDto>();
    keyUncertainties: string = "";
    quickReserve: string = "";
    quickReservePricingTarget: QuickReservePricingTargetDto[] = new Array<QuickReservePricingTargetDto>();
    quickReserveStandingLimits: QuickReserveStandingLimitsDto[] = new Array<QuickReserveStandingLimitsDto>();
    minimumBidPrices: MinimumBidPricesDto[] = new Array<MinimumBidPricesDto>();
    minimumBidPriceLongOutageOfferPrice: number = 0 ;
    minimumBidPriceLongOutageBidPrice: number = 0 ;
}
export class SpreadsDto {
    duty: string = "";
    trading_IntoGen: string = "";
    trading_BuyBackPosition: string = "";
    bM_OfferIntoGen: string = "";
    bM_OfferOutOfPump: string = "";
    bM_BidDownFromGen: string = "";
    bM_BidIntoPump: string = "";
}
export class EFABlockDto {
    efa: string = "";
    text: string = "";
}
export class QuickReservePricingTargetDto {
    time: string = "";
    station: string = "";
    service: string = "";
    pricing: number = 0;
}
export class QuickReserveStandingLimitsDto {
    service: string = "";
    parameter: string = "";
    station: string = "";
    comment: string = "";
}
export class MinimumBidPricesDto {
    station: string = "";
    type: string = "";
    noTechnicalRestrictions: string = "";
    technicalRestrictions: string = "";
}
